/**
 * Employee Web — `/me/my-leave` tab route (EW-09).
 *
 * Phase 4 Plan 04-04 Task 1 replaces the Phase 3 `<ComingSoon>` stub with the
 * `<MyLeaveBalance>` feature (balance cards + Hijri overlay + Request Leave
 * CTA + recent-requests preview).
 *
 * Breadcrumb label switches from the Phase 3 `me-profile:tabs.my-leave` key to
 * the Plan 04-01 `leaves:page.my_leave` namespace — the `leaves` namespace is
 * allow-listed in BREADCRUMB_NAMESPACES (Plan 04-01 Task 4).
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { MyLeaveBalance } from "@linkhr/employee-self-service";

export const Route = createFileRoute("/_auth/me/my-leave")({
  staticData: { breadcrumb: { labelKey: "leaves:page.my_leave" } },
  component: MyLeaveTabRoute,
});

function MyLeaveTabRoute(): JSX.Element {
  return <MyLeaveBalance />;
}
